import api from "@/lib/api";
import type {
  ApiNotificationRule,
  NotificationRulesListParams,
} from "../types";
import type { PaginatedQueryResult } from "@/types";

const ALERTS_ENDPOINTS = {
  LIST: "/notification-rules/",
  GET_ONE: (id: string) => `/notification-rules/${id}/`,
};

export class AlertsHttpRepository {
  async fetchList(
    params?: NotificationRulesListParams,
  ): Promise<PaginatedQueryResult<ApiNotificationRule>> {
    const result = await api.get(ALERTS_ENDPOINTS.LIST, { params });
    return result.data;
  }

  async fetchOne(id: string): Promise<ApiNotificationRule> {
    const result = await api.get(ALERTS_ENDPOINTS.GET_ONE(id));
    return result.data;
  }

  async create(
    payload: Partial<ApiNotificationRule>,
  ): Promise<ApiNotificationRule> {
    const result = await api.post(ALERTS_ENDPOINTS.LIST, payload);
    return result.data;
  }

  async patch(
    id: string,
    payload: Partial<ApiNotificationRule>,
  ): Promise<ApiNotificationRule> {
    const result = await api.patch(ALERTS_ENDPOINTS.GET_ONE(id), payload);
    return result.data;
  }
}
